import { ContentDto } from '@cineamo/api/models/content/ContentDto.types';

import { PurchaseReasonEnum } from '@cineamo/api/constants/PurchaseReason.enum';

import { createTicketPurchaseIntent } from '@/utils/api/ticket-purchase-intent/ticket-purchase-intent-api';
import { consumeAdClickAttribution } from '@cineamo/api/helpers/ticket-purchase-intent-helper';

// Keeps cinema-website's own API client (app-scoped transport); the ad-click attribution
// semantics (consume-once, 24h expiry, corrupted-entry guard) come from the shared helper so
// they cannot drift from the web app again.
export function onTicketButtonClick(
    showingId: number,
    purchaseReason?: PurchaseReasonEnum,
    contentId?: ContentDto['id']
) {
    createTicketPurchaseIntent({
        showing: showingId,
        purchaseReason: purchaseReason,
        ...consumeAdClickAttribution(contentId)
    }).then();
}
